import React from 'react';
import type { FeatureFlag } from '../types';
import FeatureFlagToggle from './FeatureFlagToggle';

export type FeatureFlagListProps = {
  flags: FeatureFlag[];
  disabled?: boolean;
  savingFlags?: Set<string>;
  onToggle: (flagKey: string, enabled: boolean) => void;
};

const FeatureFlagList = ({ flags, disabled, savingFlags, onToggle }: FeatureFlagListProps) => {
  if (flags.length === 0) {
    return (
      <div className="feature-flag-list feature-flag-list--empty">
        <span>登録された機能フラグはありません</span>
      </div>
    );
  }

  return (
    <div className="feature-flag-list">
      {flags.map((flag) => (
        <FeatureFlagToggle
          key={flag.key}
          flag={flag}
          disabled={disabled}
          isSaving={savingFlags?.has(flag.key)}
          onToggle={onToggle}
        />
      ))}
    </div>
  );
};

export default FeatureFlagList;
